export const ERROR_MESSAGES = {
    DEFAULT: 'Something went wrong! Please try again.',
    ERROR: 'Error!!!',
    UPLOAD_FILE: 'Error in uploading',
    DUPLICATE: 'DUPLICATE',
    FILL_ALL: 'Please Fill All Details',
    DELETE_FILE:'Error in Deleting File'
};

export const API_RESULT = {
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE'
};

export const STEPPER_CONFIG = {
    completeColor: 'var(--light-green)',
    activeColor: 'var(--royal-blue)'
}

export const ACTIVITY_TYPE = {
    AUDIT: 'Audit',
    NO_AUDIT: 'No Audit',
    PHYSICAL_AUDIT: 'Physical Audit'
}

export const ACTIVITY_TYPE_ICONS = {
    [ACTIVITY_TYPE.AUDIT]: 'audit',
    [ACTIVITY_TYPE.PHYSICAL_AUDIT]: 'physical-audit',
    [ACTIVITY_TYPE.NO_AUDIT]: 'no-audit'
}

export const SEARCH_PLACEHOLDER: any = {
    ACTIVITY: "Search for Activity",
    ACT: "Search for Act By Name",
    CITY: "Search for City Code/Name",
    LAW: "Search for Law/Description",
    RULE: "Search for Rule/Description",
    STATE: "Search for State Code/Name",
    DEPARTMENT: "Search for Department",
    VERTICAL: "Search for Vertical",
    USER: "Search for User",
    ROLE: "Search for Role",
}

export const UI_DELIMITER = ', ';
export const API_DELIMITER = ';';
export const DEBOUNCE_TIME = 750; // Milliseconds

export const EDITOR_CONFIG = {
    modules: {
        toolbar: [
            ['bold', 'italic', 'underline'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['link']
        ],
        clipboard: {
            matchVisual: false,
        }
    },
    formats: [
        'bold', 'italic', 'underline',
        'color', 'background',
        'list', 'bullet',
        'link'
    ]
};

export const EVIDENCE_TYPE = {
    MANUAL: 'manual',
    AUTOMATED: 'automated',
    DUPLICATE: 'duplicate'
}